import { webInstance } from '../../config/webConfig'
import { firebaseDb } from '../../config/firebaseConfig'
import firebase from 'firebase'

function getAgencyById(agencyId) {
  if (!!agencyId) {
    return firebaseDb
      .collection('/agency')
      .doc(agencyId)
      .get()
      .then((doc) => {
        return doc.data()
      })
  } else {
    return 'NOT_AGENCYID'
  }
}

function createAgency(agency) {
  return firebaseDb
    .collection('/agency')
    .add(agency)
    .then((res) => {
      const agencyDoc = firebaseDb.doc(`/agency/${res.id}`)

      agency.key = res.id
      agencyDoc.update(agency)

      return agency
    })
    .catch((err) => {
      return false
    })
}

function updateAgency(agencyId, data) {
  return firebaseDb
    .doc(`/agency/${agencyId}`)
    .update(data)
    .then(() => true)
    .catch(() => false)
}

async function addSettingsToAgency(agencyKey, data) {
  const { logoImage, bannerImage, bannerModel, experiencesModel } = data
  const logoId = Math.random().toString(36).substring(2)
  const bannerId = Math.random().toString(36).substring(2)

  const logoRef = firebase
    .storage()
    .ref(`agencies/${agencyKey}/settings/${logoId}`)
  const bannerRef = firebase
    .storage()
    .ref(`agencies/${agencyKey}/settings/${bannerId}`)

  if (logoImage.file && bannerImage.file) {
    const logoResponse = await logoRef.put(logoImage.file)
    const bannerResponse = await bannerRef.put(bannerImage.file)

    const logoUrl = await logoResponse.ref.getDownloadURL()
    const bannerUrl = await bannerResponse.ref.getDownloadURL()

    const updatedObject = {
      logo: logoUrl,
      settings: {
        bannerModel,
        experiencesModel,
        logo: { name: logoImage.name, url: logoUrl },
        banner: { name: bannerImage.name, url: bannerUrl },
      },
    }

    updateAgency(agencyKey, updatedObject)

    return { logoUrl, bannerUrl }
  } else if (logoImage.file) {
    const logoResponse = await logoRef.put(logoImage.file)
    const logoUrl = await logoResponse.ref.getDownloadURL()
    const bannerUrl = bannerImage.url
    const updatedObject = {
      settings: {
        bannerModel,
        experiencesModel,
        logo: { name: logoImage.name, url: logoUrl },
        banner: { name: bannerImage.name, url: bannerUrl },
      },
    }

    updateAgency(agencyKey, updatedObject)

    return { logoUrl, bannerUrl }
  } else if (bannerImage.file) {
    const bannerResponse = await bannerRef.put(bannerImage.file)
    const bannerUrl = await bannerResponse.ref.getDownloadURL()
    const logoUrl = logoImage.url
    const updatedObject = {
      settings: {
        bannerModel,
        experiencesModel,
        logo: { name: logoImage.name, url: logoUrl },
        banner: { name: bannerImage.name, url: bannerUrl },
      },
    }

    updateAgency(agencyKey, updatedObject)

    return { logoUrl, bannerUrl }
  } else {
    const bannerUrl = bannerImage.url
    const logoUrl = logoImage.url
    const updatedObject = {
      settings: {
        bannerModel,
        experiencesModel,
        logo: { name: logoImage.name, url: logoUrl },
        banner: { name: bannerImage.name, url: bannerUrl },
      },
    }

    updateAgency(agencyKey, updatedObject)

    return { logoUrl, bannerUrl }
  }
}

function createAdmin(dataAdmin) {
  return webInstance.post('/admin/create', dataAdmin)
}

function createAdminAgency(data) {
  firebaseDb
    .collection(`/admins`)
    .add(data)
    .then((res) => {
      const adminDoc = firebaseDb.doc(`/admins/${res.id}`)
      console.log(res.id, 'admins key')
      data.key = res.id
      adminDoc.update(data)

      const dataAdmin = {
        uid: res.id,
        email: data.email,
        name: data.name,
        logo: data.logoAgency,
      }

      createAdmin(dataAdmin)

      return res.id
    })
    .catch((err) => console.log(err))
}

function getAgencyByEmail(email) {
  return firebaseDb
    .collection(`/agency`)
    .where('email', '==', email)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => (data = { ...doc.data() }))
      return data
    })
}

function getAgencyByUrl(url) {
  return firebaseDb
    .collection('/agency')
    .where('agencyUrl', '==', url)
    .get()
    .then((querySnapshot) => {
      let data = {}
      querySnapshot.forEach((doc) => (data = { ...doc.data() }))
      return data
    })
}

function createContact(agencyId, contactData) {
  return firebaseDb
    .collection(`/agency/${agencyId}/contacts`)
    .add(contactData)
    .then((res) => {
      const contactDoc = firebaseDb.doc(
        `/agency/${agencyId}/contacts/${res.id}`,
      )
      contactData.key = res.id
      contactDoc.update(contactData)
      return contactData
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

async function getAllAgencies() {
  try {
    const agenciesResponse = await firebaseDb.collection(`/agency`).get()

    const data = []
    agenciesResponse.forEach((querySnapshot) => {
      data.push(querySnapshot.data())
    })

    return data
  } catch (err) {
    console.log({ err: err, from: 'getAllAgencies' })
  }
}

async function getSettingsAgency(agencyId) {
  try {
    const settingsResponse = await firebaseDb
      .collection('agency')
      .doc(agencyId)
      .collection('settings')
      .get()

    const data = []
    settingsResponse.forEach((querySnapshot) => {
      data.push(querySnapshot.data())
    })

    return { data, isEmpty: settingsResponse.empty }
  } catch (error) {
    console.log('getSettingsAgency:', error)
  }
}

export {
  getAgencyById,
  createAgency,
  updateAgency,
  addSettingsToAgency,
  createAdminAgency,
  getAgencyByEmail,
  getAgencyByUrl,
  createContact,
  getAllAgencies,
  getSettingsAgency,
}
